// extracted by mini-css-extract-plugin
module.exports = {"Data":"Data_Data__2oEqe","Calculation":"Data_Calculation__SqROr","Piece":"Data_Piece__14C1D","Message":"Data_Message__3tRWE"};